﻿<template>
    <div class="summary-discount section sm-promo">
        <label for="promo_code" class="sm-promo-label">Discount code</label>
        <div class="sm-promo-field" :class="{ 'is-success': Discount_Found, 'is-error': Discount_Not_Found }">
            <input v-on:keyup.enter="Apply_Discount()" type="text" name="promo_code" id="promo_code" class="mb-input" placeholder="Enter code" autocomplete="off" v-model="promo_code" />
            <button type="button" class="sm-promo-apply" :disabled="!Discount_Set || discount_loading" @click="Apply_Discount()">
                <svg v-if="discount_loading" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                <span v-else>Apply</span>
            </button>
        </div>
        <p class="sm-promo-msg" :class="{ 'is-success': Discount_Found == true, 'is-error': Discount_Not_Found == true }" :hidden="Discount_Found == false && Discount_Not_Found == false" v-html="promo_text()"></p>
    </div>
</template>

<script lang="ts" src="./trip_summary_discount.ts"></script>